import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import paramedicalimg from "../images/paramedical-img.jpg";


import ScrollToTop from "react-scroll-to-top";
import ParamedicalPhoto from './ParamedicalPhoto';

function Paramedical() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className='colorgallery'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Paramedical Page</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
          <ScrollToTop smooth top="100" color="maroon"/>
            <div className='colorhotel'>
                <br />

                <div className="album py-2">
                    <div className="container">

                        <h1 style={{ color: "#135880" }} className='mb-1'><b>MAA TARA COLLEGE OF PARAMEDICAL & DIAGNOSTIC CENTRE   </b></h1>

                        <h6 style={{ color: "#0A0E6C" }}>Approved by the Dept. of Health & Family Welfare, Govt of West Bengal </h6>

                        <h4 className='btn-grad66'>ASMISSION OPEN</h4>

                    </div>
                </div>


                <div className='album py-0'>
                    <div className='container'>
                        <div class="alert alert-info" role="alert">

                            <center>
                                <div className='colorsb'>
                                    <h6> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt" viewBox="0 0 16 16">
                                        <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                        <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                    </svg> VILL.-BAHIRGACHI,P.O.-KALITALADIAR,P.S.-BERHAMPORE,DIST.-MURSHIDABAD,742165.W.B.</h6>
                                    <a className='me-3' href='tel: +91 9735090503'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708" />
                                    </svg> +91 9735090503</a>

                                    <a href='tel: +91 9735020022'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708" />
                                    </svg> +91 9735020022</a>
                                </div>
                                <br />
                                <h5>1(H.S PASS) FOR ARTS & SCIENCE STUDENTS
                                </h5>

                            </center>

                        </div>
                    </div>
                </div>

                <br />
                <br />
                <div className="album py-0">
                    <div className="container">
                        <h1 style={{ color: "#0B1072" }}><b>COURSE DETAILS :</b></h1>
                        <div className="col-md-4">
                            <hr />
                        </div>

                    </div>
                </div>
                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 mt-3">
                                <img src={paramedicalimg} className="card-img-top" alt="paramedicalimg" />

                            </div>
                            <div className="col-md-8 mt-3">

                                <div className="accordion" id="accordionExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingOne">
                                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                <b style={{ color: "#0B1072" }}>UNDER STATE MEDICAL FACULTY (ONLY SCIENCE STUDENT):-  </b>
                                            </button>
                                        </h2>
                                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                            <div className="accordion-body">

                                                <div className="album py-1">
                                                    <div className="container">

                                                        <Table striped bordered hover variant="light">
                                                            <thead>
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Course Name</th>
                                                                    <th>Duration</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>1</td>
                                                                    <td>	DMLT</td>
                                                                    <td>(2 YEARS)</td>

                                                                </tr>
                                                                <tr>
                                                                    <td>2</td>
                                                                    <td>DECG</td>
                                                                    <td>(2 YEARS)</td>

                                                                </tr>
                                                                <tr>
                                                                    <td>3</td>
                                                                    <td >DECG</td>
                                                                    <td>(2 YEARS)</td>

                                                                </tr>





                                                                <tr>


                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingTwo">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                <b style={{ color: "#0B1072" }}>UNDER MURSHIDABAD UNIVERSITY (SCIENCE AND ARTS STUDENT):-  </b>
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                <div className="album py-1">
                                                    <div className="container">

                                                        <Table striped bordered hover variant="light">
                                                            <thead>
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Course Name</th>
                                                                    <th>Duration</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>1</td>
                                                                    <td>	DMLT</td>
                                                                    <td>(2 YEARS)</td>

                                                                </tr>
                                                                <tr>
                                                                    <td>2</td>
                                                                    <td>DECG</td>
                                                                    <td>(2 YEARS)</td>

                                                                </tr>
                                                                <tr>
                                                                    <td>3</td>
                                                                    <td >DECG</td>
                                                                    <td>(2 YEARS)</td>

                                                                </tr>





                                                                <tr>


                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>


                                            </div>

                                        </div>

                                    </div>


                                    {/* <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingFour">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                                <b style={{ color: "peru" }}>HOUSE KEEPING </b>
                                            </button>
                                        </h2>
                                        <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                            <div className="accordion-body">

                                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-square" viewBox="0 0 16 16">
                                                    <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5z" />
                                                    <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0" />
                                                </svg>  Update coming soon</h6>
          
                                            </div>
                                        </div>
                                    </div> */}




                                </div>
                                <br />
                                <div className='colort'>
                                    <h5 className='mt-5 mb-2'>MOB. NO.- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                    </svg> 9735090503 / 9735010022</h5>
                                    <a style={{ color: "#0e1661" }} href="mailto:  matarafoundation2023@gmail.com" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-at-fill" viewBox="0 0 16 16">
                                        <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671" />
                                        <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791" />
                                    </svg> matarafoundation2023@gmail.com </a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <br />
                <br />
            </div>
            <br />
            <div className="album py-0">
                <div className="container">
                    <h3 style={{ color: "#171A5B" }}><b>FACILITES :</b></h3>
                </div>
            </div>
            <ParamedicalPhoto/>
            <br />
            <br />

        </div>
    )
}

export default Paramedical